import { fetchHandler } from "../Handler/Handler";

export const ProductBulckUpload = async (slugname,data) => {
    try {

        const response = await fetchHandler({
            method: "POST",
            // /vendor/{{subdomine}}/enquiries/:enquiryId
            

            endpoint: `/vendor/${slugname}/bulkupload`,
            data: data,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};